import { type FC } from 'react';

import { type GeoMap } from '@editor2/types/pageElements';
import ChangesDiff from '../common/ChangesDiff';
import { elementHeader } from '../styles';

interface Props {
	title: string;
	index: number;
	initialIndex: number;
	initialElement: GeoMap;
	currentElement: GeoMap;
	attributeChanges: any;
	parentName: string;
}

const GeoMapDataDiff: FC<Props> = (props) => {
	const {
		title,
		index,
		initialIndex,
		initialElement,
		currentElement,
		attributeChanges,
		parentName
	} = props;

	const { data, labels, colors } = attributeChanges;

	const getColumnValue = (label, value, colors) => {
		if (label === 'Group') {
			const group = colors.find((item) => item.id === value);
			return `${label}: ${group?.name || ''}`;
		}

		return `${label}: ${value || ''}`;
	};

	const mapDataToChangesString = (data, labels, colors) => {
		const dataRows = Object.keys(data).map((key) => {
			const columnValues = labels
				.map((label, index) => getColumnValue(label, data[key][index], colors))
				.join(' ');

			return `${key} - ${columnValues}`;
		});
		return dataRows.join('\n');
	};

	const mapColorsToChangesString = (colors) => {
		const groupRows = colors.map(({ name, color }) => {
			return `${name}: ${color}`;
		});
		return groupRows.join('\n');
	};

	return (
		<ChangesDiff
			title={title}
			index={index}
			initialIndex={initialIndex}
			initial={{
				...initialElement,
				...(initialElement && {
					data: mapDataToChangesString(
						initialElement.data,
						initialElement.labels,
						initialElement.colors
					) as any,
					colors: mapColorsToChangesString(initialElement.colors)
				})
			}}
			attributeChanges={{
				...attributeChanges,
				...(data && {
					data: mapDataToChangesString(
						data,
						labels || currentElement.labels,
						colors || currentElement.colors
					)
				}),
				...(colors && { colors: mapColorsToChangesString(colors) })
			}}
			parentName={parentName}
			styles={elementHeader}
		/>
	);
};

export default GeoMapDataDiff;
